import { useState } from "react";
import utils from "../../helpers/utils";
interface ExerciseLike {
  image?: string;
  image_url?: string;
  professional_id?: number;
  all_view?: boolean;
}

interface ExerciseImageProps {
  exercise: ExerciseLike;
  width?: number;
  height?: number;
  className?: string;
  alt?: string;
  placeholder?: string;
}

/**
 * Imagem de exercício com fallback para image_url (presigned) em caso de 404.
 * Tenta primeiro a URL com resize (DIT/API); se falhar, usa image_url.
 */
export function ExerciseImage({
  exercise,
  width,
  height,
  className = "",
  alt = "Exercise",
  placeholder,
}: ExerciseImageProps) {
  const [useFallback, setUseFallback] = useState(false);

  const primarySrc =
    exercise.image && exercise.image.trim() !== ""
      ? utils.getUriImage(
          exercise.image,
          exercise.all_view ? "all_view" : String(exercise.professional_id ?? "all_view"),
          width != null || height != null ? { width, height } : undefined,
        )
      : exercise.image_url || placeholder || "";

  const fallbackSrc = exercise.image_url || primarySrc;

  const src = useFallback ? fallbackSrc : primarySrc;

  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => {
        if (!useFallback && fallbackSrc && fallbackSrc !== primarySrc) {
          setUseFallback(true);
        }
      }}
    />
  );
}
